import { useCallback, useMemo } from "react";

import { Funnel } from "components/icons/generated";
import { type TableCellAction } from "ds/components/Table/Row/CellContent";
import useTypedContext from "hooks/useTypedContext";
import { ApplyFiltersContext } from "components/Filters";

import useIacManagementAnalytics from "../useIacManagementAnalytics";
import { ADD_TO_FILTERS } from "./constants";
import {
  ResourcesSuggestions,
  SEARCH_MANAGED_ENTITIES_SUGGESTIONS_DICTIONARY,
} from "../useIacManagementFilters/constants";

const useCellFilterAction = (
  column: ResourcesSuggestions,
  filterValue: string
): TableCellAction => {
  const { applyFilter, applySpaceFilter } = useTypedContext(ApplyFiltersContext);
  const { trackAnalytics } = useIacManagementAnalytics();

  const handleApplyFilter = useMemo(
    () => (column === ResourcesSuggestions.Space ? applySpaceFilter : applyFilter),
    [column, applySpaceFilter, applyFilter]
  );

  const action = useCallback(() => {
    handleApplyFilter(column, SEARCH_MANAGED_ENTITIES_SUGGESTIONS_DICTIONARY)(filterValue);
    trackAnalytics("Add to filters clicked", { type: column });
  }, [handleApplyFilter, column, filterValue, trackAnalytics]);

  return useMemo(
    () => ({
      icon: Funnel,
      title: ADD_TO_FILTERS,
      action,
    }),
    [action]
  );
};

export default useCellFilterAction;
